export default "__VITE_ASSET__BZjX21Iy__"